export const STATUS = {
  QUEUED: 'QUEUED',
  IN_PROGRESS: 'IN_PROGRESS',
  UNRATED: 'UNRATED',
  NOT_SUPPORTED: 'FAILED',
  UNSUPPORTED: 'UNSUPPORTED',
  SUCCESS: 'SUCCEEDED',
  NOT_FOUND: 'NOT_FOUND',
  NO_SCENARIOS: 'WITHOUT_SCENARIOS',
};
